export const getUmrahTourPrice = (
  price?: number | string,
  passengers = 1,
): number => {
  return Number(price || 0) * passengers
}
